(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/notifications/components/marketplace.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/notifications/components/marketplace.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _svs$ui$reactForm = svs.ui.reactForm,
  Fieldset = _svs$ui$reactForm.Fieldset,
  Checkbox = _svs$ui$reactForm.Checkbox;
const TopHeader = svs.myProfile.react.shared.components.TopHeader;
const useMarketplace = svs.myProfile.react.pages.notifications.hooks.useMarketplace;
const notificationsMarketplaceService = svs.myProfile.react.pages.notifications.notificationsMarketplaceService;
const trackMarketplace = svs.myProfile.react.shared.tracking.trackMarketplace;
const showSettingsTechnicalError = svs.myProfile.react.shared.dialogs.showSettingsTechnicalError;
const _svs$myProfile$consta = svs.myProfile.constants,
  titles = _svs$myProfile$consta.titles,
  icons = _svs$myProfile$consta.icons;
const ID = ['SvS_TB_marketplace_wagerCreated_o2k', 'SvS_TB_marketplace_shareRefunded_o2k'];

const Marketplace = _ref => {
  let setShouldShowApiError = _ref.setShouldShowApiError;
  const _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    playerMarketplaceData = _React$useState2[0],
    setPlayerMarketplaceData = _React$useState2[1];
  const _React$useState3 = React.useState(svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)),
    _React$useState4 = _slicedToArray(_React$useState3, 1),
    isPlayerLoggedIn = _React$useState4[0];
  useMarketplace(setPlayerMarketplaceData, setShouldShowApiError);
  const findIdInfo = id => {
    const notification = playerMarketplaceData.find(item => item.notificationType === id);
    const checked = notification.transports.find(item => item.transportType === 'Mail');
    return {
      notification,
      checked
    };
  };
  const handleMarketplaceCheckbox = async isChecked => {
    svs.myProfile.logger.debug("**** main handleMarketplaceCheckbox");
    const transportType = {
      enabled: !isChecked,
      transportType: 'Mail'
    };
    const newModel = playerMarketplaceData.slice();
    ID.forEach(id => {
      const _findIdInfo = findIdInfo(id),
        notification = _findIdInfo.notification;
      const mailNotificationIndex = notification.transports.findIndex(item => item.transportType === 'Mail');
      const transportArray = notification.transports.slice();
      transportArray[mailNotificationIndex] = transportType;
      const newNotification = _objectSpread(_objectSpread({}, notification), {}, {
        transports: transportArray
      });
      const notificationIndex = playerMarketplaceData.findIndex(item => item.notificationType === id);
      newModel[notificationIndex] = newNotification;
    });
    if (isPlayerLoggedIn) {
      try {
        const _await$notificationsM = await notificationsMarketplaceService.putCustomersMarketplaceDataItemsAsync(newModel),
          status = _await$notificationsM.status,
          error = _await$notificationsM.error;
        if (error || status !== 'success') {
          svs.myProfile.logger.debug('handleMarketplaceCheckbox: error: ', error);
          showSettingsTechnicalError();
        } else {
          trackMarketplace(!isChecked);
          svs.myProfile.logger.debug('handleMarketplaceCheckbox: success :)');
          setPlayerMarketplaceData(newModel);
        }
      } catch (error) {
        showSettingsTechnicalError();
        svs.myProfile.logger.debug('handleMarketplaceCheckbox: error: ', error);
      }
    }
  };
  let isChecked = false;
  ID.forEach(id => {
    var _notification$transpo;
    const notification = playerMarketplaceData === null || playerMarketplaceData === void 0 ? void 0 : playerMarketplaceData.find(item => item.notificationType === id);
    const checked = notification === null || notification === void 0 || (_notification$transpo = notification.transports) === null || _notification$transpo === void 0 ? void 0 : _notification$transpo.find(item => item.transportType === 'Mail');
    if (checked !== null && checked !== void 0 && checked.enabled) {
      isChecked = true;
    }
  });
  return React.createElement("div", null, playerMarketplaceData && playerMarketplaceData.length > 0 && React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(TopHeader, {
    icon: icons.FRACTIONGAME,
    title: titles.FRACTIONGAME
  }), React.createElement("p", null, "V\xE4lj om du vill f\xE5 mejl med uppdateringar om andelsspel du har k\xF6pt. Du f\xE5r notifieringar n\xE4r alla andelar i ett andelsspel s\xE4ljs och din reservation omvandlas till ett k\xF6p, samt om ett andelsspel blir inst\xE4llt och din reservation \xE5terbetalas."), React.createElement(Fieldset, {
    legend: titles.FRACTIONGAME,
    srOnly: true
  }, React.createElement(Checkbox, {
    checked: isChecked,
    onChange: () => handleMarketplaceCheckbox(isChecked)
  }, "Skicka uppdateringar om andelsspel jag har k\xF6pt"))));
};
svs.myProfile.react.pages.notifications.components.Marketplace = Marketplace;

 })(window);